import * as React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Stack, TextField, FormControl, 
  InputLabel, Select, MenuItem, Button, IconButton, InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function EditUserDialog({ open, user, onClose, onSave }) {
  const [form, setForm] = React.useState(user || null);
  const [submitting, setSubmitting] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState('');

  React.useEffect(() => { 
    setForm(user || null);
    setNewPassword('');
    setShowPassword(false);
  }, [user]);

  const handleSave = async () => {

    if (!form?.email || !form?.nom || !form?.prenom) return;
    setSubmitting(true);
    try { 
      const dataToSave = { ...form };
      // Ajouter le nouveau mot de passe seulement s'il a été renseigné
      if (newPassword && newPassword.trim().length > 0) {
        dataToSave.password = newPassword;
      }
      await onSave(dataToSave); 
    }
    finally { setSubmitting(false); }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Modifier l'utilisateur</DialogTitle>
      <DialogContent>
        {form && (
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField 
              label="Email" 
              type="email" 
              value={form.email} 
              onChange={(e) => setForm({ ...form, email: e.target.value })} 
              required 
            />
            <TextField 
              label="Nouveau mot de passe (optionnel)" 
              type={showPassword ? 'text' : 'password'}
              value={newPassword} 
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Laisser vide pour ne pas modifier"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPassword ? "masquer le mot de passe" : "afficher le mot de passe"}
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField 
                fullWidth 
                label="Prénom" 
                value={form.prenom} 
                onChange={(e) => setForm({ ...form, prenom: e.target.value })} 
                required 
              />
              <TextField 
                fullWidth 
                label="Nom" 
                value={form.nom} 
                onChange={(e) => setForm({ ...form, nom: e.target.value })} 
                required 
              />
            </Stack>
            <FormControl fullWidth>
              <InputLabel>Rôle</InputLabel>
              <Select 
                value={form.role} 
                label="Rôle" 
                onChange={(e) => setForm({ ...form, role: e.target.value })}
              >
                <MenuItem value="comptable">Comptable</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={handleSave} disabled={submitting} variant="contained">
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
}